import { render, staticRenderFns } from "./ManualTax.vue?vue&type=template&id=9983f7e2&scoped=true&"
import script from "./ManualTax.vue?vue&type=script&lang=js&"
export * from "./ManualTax.vue?vue&type=script&lang=js&"
import style0 from "./ManualTax.vue?vue&type=style&index=0&id=9983f7e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9983f7e2",
  null
  
)

export default component.exports